import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import InputField from 'components/LoginForm/Input';

const MagicLink = ({ defaultVal = '', change, back, submit, loadingAnimRegister }) => (
  <div className="magicLink">
    <p>{i18n.translate('loginScreen.version2.magicLinkTitle')}</p>
    <InputField
      defaultVal={defaultVal}
      change={change}
      fieldType="email"
      fieldName="email"
      fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
      icon="envelope"
      focus
      line
    />
    <div className="login__form--buttons">
      <Link to="/login">
        <button type="button" onClick={back} className="Email__input--button btnInverse">
          {i18n.translate('general.back')}
        </button>
      </Link>
      <button type="submit" onClick={submit} className="Email__input--button">
        {loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        ) : (
          'Submit'
        )}
      </button>
    </div>
  </div>
);

export default MagicLink;

MagicLink.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};
